import React from 'react'
import classNames from 'classnames'

export const Card = ({ title, subtitle, icon, className, bgColor }) => {
  return (
    <div
      className={`flex flex-row items-center md:justify-between justify-between gap-2 !min-w-full md:h-[80px] h-[100px] px-2 py-3 rounded-md border border-[#F0F0F5] ${className} ${
        bgColor ? bgColor : ''
      }`}
    >
      <div className='flex flex-col gap-2 w-full'>
        <div className='flex gap-2 items-center w-full'>
          <div>
            <img src={icon} alt='centelHR' height={'40px'} width={'40px'} />
          </div>
          <span className='font-bold text-[13px] leading-[12px] text-[#78787D] flex flex-col text-center'>
            {title}
          </span>
        </div>
        <span className='font-bold text-[15px] ml-2'>{subtitle}</span>
      </div>
    </div>
  )
}
